<template>
  <v-dialog
    v-model="isVisible"
    no-click-animation
    persistent
    :width="'55%'"
  >
    <v-card>
      <v-card-title>
        <h3>查詢常用帳戶</h3>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-btn class="info" dark text v-if="mode === '0'" @click="mode = '1'">新增</v-btn>
          <v-btn class="info" dark text v-if="mode === '1'" @click="mode = '0'">查詢</v-btn>
        </v-layout>
        <div v-if="mode === '1'">
          <v-layout>
            <v-flex md6 xs6>
              <h3>代扣銀行名稱</h3>
              <v-autocomplete :items="getBankInfo"
                              item-text="branch"
                              item-value="key"
                              v-model="bankInfo.bankId"
                              :label="`銀行名稱`"
                              outline
              ></v-autocomplete>
            </v-flex >
            <v-flex md6 xs6>
              <h3>代扣分行名稱</h3>
              <v-autocomplete :items="getBankSubInfo"
                              item-text="branch"
                              item-value="code"
                              v-model="bankInfo.bankSubId"
                              label="分行名稱"
                              outline
              ></v-autocomplete>
              <!--              <v-text-field v-model="item.bankSubName" label="分行名稱" outline></v-text-field>-->
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 xs6>
              <h3>戶名</h3>
              <v-text-field v-model="bankInfo.accountName" label="戶名" outline></v-text-field>
            </v-flex >
            <v-flex md6 xs6>
              <h3>帳號</h3>
              <v-text-field v-model="bankInfo.bankAccount" label="帳號" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 xs12>
              <h3>備註</h3>
              <v-text-field v-model="bankInfo.comment" label="comment" outline></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-spacer></v-spacer>
            <span class="red--text" v-if="message !== ''">{{message}}</span>
            <v-btn class="primary" dark text :loading="saveLoading" @click="saveData">儲存</v-btn>
          </v-layout>
        </div>
        <div v-else>
          <v-layout>
            <v-flex>
              <v-text-field v-model="searchValue"
                            placeholder="查詢常用帳戶" label="查詢常用帳戶">
              </v-text-field>
              <v-btn class="primary" :loading="loading" dark text @click="loadData">查詢</v-btn>
            </v-flex>
          </v-layout>
          <br>
          <div v-if="items.length">
            <h3>查詢結果</h3>
            <br>
            <v-layout v-for="item of items" :key="item.bankId">
              <v-flex>
                <span class="title">{{item.bankId }}{{item.bankName }} | {{item.bankSubId }}{{item.bankSubName }} | {{item.accountName }} | {{item.bankAccount}} | {{item.comment}}</span>
                <v-btn class="primary" :loading="loading" dark text @click="confirmEvent(item)">套用</v-btn>
                <v-btn color="red" :loading="saveLoading" dark text @click="deleteEvent(item.bankAccount)">刪除</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="red" dark text @click="cancelEvent">關閉</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from '@/mixins/common';
import { searchBankInfo } from '@/store/actions';
import { mapActions, mapGetters } from 'vuex';
import bankCodeList from '@/assets/bank_data.json';

export default {
  name: 'BankListDialog',
  props:{
    visible: Boolean,
    tag: String,
  },
  data() {
    return {
      bankCopyList: JSON.parse(JSON.stringify(bankCodeList)),
      mode: '0',
      bankInfo: {
        agentId: '',
        bankId: '',
        bankName: '',
        bankSubId:'',
        bankSubName: '',
        bankAccount: '',
        accountName: '',
        comment: '',
      },
      isVisible: false,
      message: '',
      items: [],
      loading: false,
      saveLoading: false,
      searchValue: '',
      selectBank: null
    }
  },
  mixins:[common],
  watch: {
    visible(value) {
      this.isVisible = value;
      this.bankInfo.agentId = this.getUserInfo.agentId;
      this.mode = '0';
      this.items = [];
      this.searchValue = '';
      this.message = '';
    },
    isVisible(value) {
      if (!value) {
        this.cancelEvent()
      }
    },
    'bankInfo.bankId'(value){
      if (value && this.bankInfo){
        const bankInfo = this.bankCopyList[value];
        this.bankInfo.bankName = bankInfo.branch;
        console.log(`bankId = ${value} | bankName = ${this.bankInfo.bankName}`);
      }
    },
    'bankInfo.bankSubId'(value){
      console.log(`bankSubId  = ${value}`);
      if (value && this.bankInfo && this.bankInfo.bankId){
        const bankInfo = this.bankCopyList[this.bankInfo.bankId];
        const find = bankInfo.child.find(b=>b.code === `${this.bankInfo.bankId}${value}`);
        console.log(`bankInfo.child  = ${JSON.stringify(bankInfo.child)}`);
        if (find){
          this.bankInfo.bankSubName = find.branch;
          console.log(`bankSubName  = ${this.bankInfo.bankSubName}`);
        }
      }
    }
  },
  computed:{
    ...mapGetters(["getUserInfo"]),
    getBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.bankInfo.bankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
  },
  methods: {
    ...mapActions(['searchBankInfo', 'saveBankInfo', 'deleteBankInfo']),
    async saveData(){
      try {
        this.saveLoading = true;
        const res = await this.saveBankInfo(this.bankInfo);
        const result = res.data;
        this.message = result.message;
        this.saveLoading = false;
      }catch (e) {
        console.log(e);
        this.message = '發生錯誤'
      } finally {
        this.saveLoading = false;
      }
    },
    async deleteEvent(bankAccount){
      try {
        this.saveLoading = true;
        const res = await this.deleteBankInfo({ bankAccount: bankAccount,
          agentId: this.getUserInfo.agentId });
        await this.loadData();
        this.saveLoading = false;
      } catch (e) {
        console.log(e);
        this.message = '發生錯誤'
      }
    },
    cancelEvent(){
      this.isVisible = false;
      this.$emit('cancelEvent');
    },
    async loadData(){
      if (this.searchValue === ''){
        this.message = '請輸入查詢條件';
        return;
      }
      try {
        this.loading = true;
        const res = await this.searchBankInfo({
          searchQuery:[
            { key: 'bankId', value:  this.searchValue},
            { key: 'bankAccount', value:  this.searchValue},
            { key: 'bankSubId', value:  this.searchValue},
            { key: 'accountName', value:  this.searchValue},
            { key: 'bankName', value:  this.searchValue},
            { key: 'bankSubName', value:  this.searchValue},
            { key: 'comment', value:  this.searchValue},
          ],
          agentId: this.getUserInfo.agentId,
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.items = result.data.list;
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    confirmEvent(item){
      this.$emit('confirmEvent', { tag: this.tag, item});
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/BankListDialog.vue